import BaseCollection from '@spa/apps/trustup-pro-base-js/collections/BaseCollection';
import WorksitePhaseTrustUpIOTask from '@spa/apps/trustup-pro-worksite-js/models/WorksitePhaseTrustUpIOTask';

export default class WorksitePhaseTrustUpIOTaskCollection extends BaseCollection
{

    constructor(items, worksitePhase)
    {
        super(items, {
            modelClass: WorksitePhaseTrustUpIOTask
        });

        this.worksitePhase = worksitePhase;
    }

    itemShouldBeInCollection(task)
    {
        return task.model_type == 'worksite-phase' && task.model_id == this.worksitePhase.uuid;
    }

    /**
     * Ensure that all items pushed to the collection are of the correct WorksitePhaseTrustUpIOTask class.
     * Since the WorksitePhaseTrustUpIOTask model only extends the TrustUpIOTask
     * model to listen the events and uses custom components (context menu, modals)
     * we need to convert the items to the correct class so the model's methods uses the correct components' name.
     *
     * Without this, the user wouldn't be able to right click on task that was added
     * via the 'trustup-io-tasks:task:created' event.
     */
    addItem(item)
    {
        if ( typeof item.constructor.getPrefix == 'function' && item.constructor.getPrefix() == 'trustup-io-task:task' ) {
            console.log('Converting task to phaseTask', item);
            item = this.convertTaskToWorksitePhaseTrustUpIOTask(item);
            console.log('Converted task to phaseTask', item);
        }

        super.addItem(item);
    }

    convertTaskToWorksitePhaseTrustUpIOTask(task)
    {
        let phaseTask = new WorksitePhaseTrustUpIOTask(
            {...task.originalData, ...task.data()}
        );
        task.destroy();

        return phaseTask;
    }

}